'use strict';

/**
 * if a link is present on the current page that goes to onboarding, we count that as an impression
 */

$(function() {

    var impressions =
        $('a').filter(isOnboardingLink).map(extractProductId);

    if (impressions.length > 0) {
        dataLayer.push({
            'ecommerce': {
                'impressions': impressions.map(function (productId, idx) {
                    return {
                        id: productId,
                        position: idx
                    };
                })
            }
        });
    }

    function isOnboardingLink() {
        return !!(/registration\/sales/.exec(this.href));
    }

    function extractProductId() {
        var match = /(?:\?|&)product=([^&]+)(?:&|$)/.exec(this.href);
        return match && match.length > 0 ? match[1] : '2350982-1-1';
    }

});
